import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../../../redux/api/api";
import { TransportRegisterByCategoryResponse, TransportRegisterByTypeResponse } from "./types";

export interface TransportRegisterFilter {
  page?: number;
  size?: number;
  year?: number;
  category?: string;
  territorialUnitIds?: number[];
}

export const transportregisterApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransportRegisterByCategory: builder.query<TransportRegisterByCategoryResponse, TransportRegisterFilter>({
      query: (filter) => ({
        url: "/departments/mechanization/agricultural-machinery-register/analytical-data/by-category",
        method: "POST",
        body: filter,
      }),
      keepUnusedDataFor: 0, 
    }),
    getTransportRegisterByType: builder.query<TransportRegisterByTypeResponse, TransportRegisterFilter>({
      query: (filter) => ({
        url: "/departments/mechanization/agricultural-machinery-register/analytical-data/quantity",
        method: "POST",
        body: filter,
      }),
      keepUnusedDataFor: 0, 
    }),
  }),
  overrideExisting: false, 
});



export const {
  useGetTransportRegisterByCategoryQuery,
  useGetTransportRegisterByTypeQuery,
} = transportregisterApi;
